import React from "react";
import { Outlet, useParams } from "react-router-dom";
import Banner from "@/components/Banner";
import { useQuery } from "@apollo/client";
import { GET_PENDING_GRADUATION_REQUESTS_QUERY } from "./queries";
import { mapGraduationRequestsFromUniversities, isEligibleForGraduation } from "./_utils";
import pluralize from "@/lib/pluralize";

export default function GraduationEligibleLayout() {
  const { universityId } = useParams();

  // Get graduation requests data for eligibility banner
  const { data: graduationRequestsData } = useQuery(GET_PENDING_GRADUATION_REQUESTS_QUERY, {
    variables: { legacyId: universityId },
    skip: !universityId
  });

  // Calculate eligibility statistics
  const eligibilityStats = React.useMemo(() => {
    if (!graduationRequestsData) {
      return { total: 0, eligible: 0, ineligible: 0 };
    }

    const students = mapGraduationRequestsFromUniversities(graduationRequestsData);
    const total = students.length;
    const eligible = students.filter(isEligibleForGraduation).length;
    const ineligible = total - eligible;

    return { total, eligible, ineligible };
  }, [graduationRequestsData]);

  return (
    <>
      {/* Eligibility Banner - positioned above content */}
      {eligibilityStats.ineligible > 0 && (
        <div className="mt-6">
          <Banner
            variant="warn"
            inline={true}
            description={`${eligibilityStats.ineligible} ${pluralize(eligibilityStats.ineligible, "student")} ${
              eligibilityStats.ineligible === 1 ? "does" : "do"
            } not meet the requirements for graduation. Please remove them from the eligibility list before finalizing graduation.`}
            subText={
              eligibilityStats.eligible > 0
                ? `${eligibilityStats.eligible} ${pluralize(
                    eligibilityStats.eligible,
                    "student"
                  )} are eligible for graduation.`
                : undefined
            }
          />
        </div>
      )}
      <Outlet />
    </>
  );
}
